import { WithValidated } from '../../../../lib/types/helperTypes';
import { MappedAEMProperties } from '../../../../types';
import styles from './Text.module.scss';
import ContentBlockView, { ContentBlockViewProps } from '../../../common/ContentBlockView/ContentBlockView';
import Layout from '../../../common/Layout/Layout';

export type AemTextProps = ContentBlockViewProps & MappedAEMProperties;
export type TextProps = WithValidated<AemTextProps, 'contentBlock'>;

const Text = (props: TextProps) => (
  <Layout className={styles.container}>
    <ContentBlockView {...props} />
  </Layout>
);

export default Text;
